/*
 * @FileName       : tenants.actions.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action class for reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { action } from 'typesafe-actions';
import { INVOICES } from '../constants/actions';
import {
	InvoicesFilter,
	InvoicesList,
	PatchInvoiceAbwPayload,
	PatchInvoiceOmitDto,
	PatchInvoiceReadyPayload,
	PatchInvoiceStatus,
	SendAbwReminderEmail,
	TransmitToSapRequest,
} from '../models/invoices/invoices';
import { ResultSet } from '../models/common/result.set';

export const getInvoiceList = (data: InvoicesFilter) => action(INVOICES.LIST, data);
export const successInvoiceList = (data: ResultSet<InvoicesList> | null) => action(INVOICES.LIST_RESPONSE, data);
export const openInvoicePaymentPage = (data: any) => action(INVOICES.OPEN_PAYMENT_PAGE, data);
export const paymentConfirmation = (data: any) => action(INVOICES.PAYMENT_CONFIRMATION, data);
export const setPaymentConfirmed = (paymentIsConfirmed: boolean) =>
	action(INVOICES.SET_PAYMENT_CONFIRMED, paymentIsConfirmed);
export const clearInvoicesList = () => action(INVOICES.CLEAR_INVOICES_LIST);
export const getInvoiceRequests = (payload: any) => action(INVOICES.GET_REQUESTS, payload); // Makes HTTP request
export const setInvoiceRequests = (data: any) => action(INVOICES.SET_REQUESTS, data); // Saves results to memory
export const patchInvoiceRequestAbwSelection = (payload: PatchInvoiceAbwPayload) =>
	action(INVOICES.PATCH_REQUEST_ABW, payload); // Makes HTTP request
export const patchInvoiceRequestOmittal = (payload: PatchInvoiceOmitDto) =>
	action(INVOICES.PATCH_REQUEST_OMITTAL, payload); // Makes HTTP request
	export const patchInvoiceRequestOmittalBulk = (payload: any) =>
	action(INVOICES.PATCH_REQUEST_OMITTAL_BULK, payload); // Makes HTTP request
export const patchMakeAllInvoicesReady = (payload?: PatchInvoiceReadyPayload) =>
	action(INVOICES.PATCH_MAKE_ALL_INVOICES_READY, payload); // For the "Move ABW to Selections" button
export const sendAbwReminderEmail = (payload: SendAbwReminderEmail) => action(INVOICES.SEND_ABW_REMINDER_EMAIL, payload);
export const transmitRequestsToSap = (payload: TransmitToSapRequest) => action(INVOICES.TRANSMIT_REQUESTS_TO_SAP, payload);
export const updateInvoiceStatus = (payload: PatchInvoiceStatus) => action(INVOICES.UPDATE_INVOICE_STATUS, payload);
